import React from "react";
import { Image, TouchableOpacity, View } from "react-native";
import { ButtonTypeDLS, ButtonWidthTypeToken, ColorTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import { Button } from "../../button/Button";
const ASESDocumentsUnderReview = ({ height, triggerAction, needHelpAction, isFromEnhanceLimit, continueToDashboardAction }) => {
    const bottomView = () => {
        return (React.createElement(View, null,
            isFromEnhanceLimit ?
                React.createElement(View, { style: { marginBottom: 24, marginHorizontal: 16 } },
                    React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Continue to dashboard", width: ButtonWidthTypeToken.FULL, onPress: () => {
                            triggerAction({
                                ...continueToDashboardAction
                            });
                        } }))
                : React.createElement(React.Fragment, null),
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'center', marginBottom: 16 } },
                React.createElement(Typography, { label: "Need help? ", typeDLS: TypographyTypeDLS.B0R, color: ColorTokens.Grey_Night }),
                React.createElement(TouchableOpacity, { onPress: () => {
                        triggerAction({
                            ...needHelpAction
                        });
                    }, activeOpacity: 1 },
                    React.createElement(Typography, { label: "Contact us", typeDLS: TypographyTypeDLS.B0S, color: ColorTokens.Primary_100 })))));
    };
    const bodyView = () => {
        return (React.createElement(View, { style: {
                paddingHorizontal: 24,
                height: height - 64,
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center'
            } },
            React.createElement(Image, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/documents_under_review.png" }, style: { width: 164, height: 164, marginBottom: 16 } }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: "Uploaded documents under review", color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, label: "You should receive a response within 1-2 business days.", color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }))));
    };
    return (React.createElement(View, { style: { marginHorizontal: -16 } },
        React.createElement(BoilerPlate, { height: height - 16, bottomChildren: React.createElement(React.Fragment, null, bottomView()) }, React.createElement(React.Fragment, null, bodyView()))));
};
export default (ASESDocumentsUnderReview);
